export default class Unit {
  public constructor(
    public id: number | null = null,
    public name: string = ""
  ) {}
}
